<template>
  <section class="products">
    <div class="products__header">
      <span class="section-label">Collections</span>
      <h2 class="products__title">시그니처 컬렉션</h2>
      <p class="products__subtitle">
        공간을 채우는 Perfume Wiz 시그니처 향
      </p>
    </div>

    <div class="products__grid">
      <div
        class="products__card"
        v-for="product in products"
        :key="product.id"
      >
        <div class="products__card-img-wrap">
          <img :src="product.image" :alt="product.name" class="products__card-img" />
          <div class="products__card-overlay">
            <button class="products__card-btn" @click="openModal(product)">자세히 보기</button>
          </div>
        </div>
        <div class="products__card-body">
          <span class="products__card-collection">{{ product.collection }}</span>
          <h3 class="products__card-name">{{ product.name }}</h3>
          <p class="products__card-desc">{{ product.desc }}</p>
          <span class="products__card-price">{{ product.price }}</span>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <transition name="modal-fade">
      <div class="modal-backdrop" v-if="selected" @click.self="closeModal">
        <div class="modal">
          <button class="modal__close" @click="closeModal">✕</button>
          <div class="modal__layout">
            <div class="modal__img-wrap">
              <img :src="selected.image" :alt="selected.name" class="modal__img" />
            </div>
            <div class="modal__content">
              <span class="modal__collection">{{ selected.collection }}</span>
              <h2 class="modal__name">{{ selected.name }}</h2>
              <p class="modal__price">{{ selected.price }}</p>
              <p class="modal__notice">※ 디퓨저 액체 색상은 향의 특징을 표현하기 위해 연출된 색상이며, 실제 제품의 색상과는 다를 수 있습니다.</p>
              <div class="modal__divider" />
              <p class="modal__desc">{{ selected.fullDesc }}</p>
              <div class="modal__notes">
                <div class="modal__note" v-for="note in selected.notes" :key="note.type">
                  <span class="modal__note-type">{{ note.type }}</span>
                  <span class="modal__note-value">{{ note.value }}</span>
                </div>
              </div>
              <a :href="kakaoUrl" target="_blank" rel="noopener" class="modal__cta">
                카카오톡으로 구매 문의
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'ProductSection',
  data() {
    return {
      selected: null,
      kakaoUrl: 'https://pf.kakao.com/_xkxkFZX/chat',
      products: [
        {
          id: 1,
          collection: 'Collection',
          name: 'NO.1',
          desc: '달콤한 체리에 상큼함을 더한 시그니처 향\n공간을 빠르게 채우는 강한 발향',
//          fullDesc: '진하고 달콤한 블랙체리 향을 중심으로, 오랑쥬 베르의 상큼함과 화이트머스크의 부드러운 잔향이 더해진 Perfume Wiz의 시그니처 향입니다. 처음에는 상큼하게 퍼지고, 이후 달콤한 체리 향이 공간을 채우며, 마지막에는 부드럽고 안정적인 잔향으로 마무리됩니다.',
          fullDesc: '진하고 달콤한 향을 중심으로, 상큼함 시트러스와 머스크의 부드러운 잔향이 더해진 Perfume Wiz의 시그니처 향입니다. 처음에는 상큼하게 퍼지고, 이후 달콤한 체리 향이 공간을 채우며, 마지막에는 부드럽고 안정적인 잔향으로 마무리됩니다.',
          price: '₩ 16,900 (120ml)',
          image: require('@/assets/images/s3_1.png'),
          notes: [
            { type: 'TOP', value: 'Fresh Citrus' },
            { type: 'MIDDLE', value: 'Sweet Cherry' },
            { type: 'BASE', value: 'Soft Musk' }
          ]
        },
        {
          id: 2,
          collection: 'Collection',
          name: 'NO.2',
          desc: '달콤한 복숭아 향에 은은한 비누향\n부드럽고 기분 좋은 공간 향',
          fullDesc: '달콤하고 부드러운 복숭아 향을 중심으로, 베르가못의 상큼함과 클린솝의 깨끗한 느낌, 화이트머스크의 잔향이 더해진 향입니다. 처음에는 은은하게 퍼지는 상큼함이 느껴지고, 이후 달콤한 복숭아 향이 공간을 채우며, 마지막에는 부드럽고 편안한 잔향으로 마무리됩니다.',
          price: '₩ 16,900 (120ml)',
          image: require('@/assets/images/s3_4.png'),
          notes: [
            { type: 'TOP', value: 'Bergamot' },
            { type: 'MIDDLE', value: 'Peach, Clean Soap' },
            { type: 'BASE', value: 'White Musk' }
          ]
        },
        {
          id: 3,
          collection: 'Collection',
          name: 'NO.3',
          desc: '깨끗하고 부드러운 코튼향\n은은하게 오래 남는 데일리 향',
//          fullDesc: '화이트머스크를 베이스로 클린솝 향을 더해, 세탁 후의 깨끗한 느낌을 그대로 담은 향입니다. 자극적이지 않으면서도 공간 전체에 은은하고 자연스럽게 퍼지며, 편안하고 안정적인 분위기를 만들어줍니다.',
          fullDesc: '클린솝의 산뜻함과 머스크의 부드러운 더해, 세탁 후의 깨끗한 느낌을 그대로 담은 향입니다. 자극적이지 않으면서도 편안하게 퍼지며, 은은하고 포근한 잔향이 오래 남습니다.',
          price: '₩ 16,900 (120ml)',
          image: require('@/assets/images/s3_2.png'),
          notes: [
            { type: 'TOP', value: 'Clean Soap' },
            { type: 'MIDDLE', value: 'Soft Cotton' },
            { type: 'BASE', value: 'Warm Musk' }
          ]
        },

      ]
    }
  },
  methods: {
    openModal(product) {
      this.selected = product
      document.body.style.overflow = 'hidden'
    },
    closeModal() {
      this.selected = null
      document.body.style.overflow = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables';

.products {
  background-color: $color-forest;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 60px;
  overflow: hidden;

  @media (max-width: $bp-mobile) {
    padding: 80px 0 80px 0;
    justify-content: flex-start;
    align-items: flex-start;
    height: auto !important;
    overflow: visible;
  }
}

.products__header {
  text-align: center;
  margin-bottom: 28px;

  @media (max-width: $bp-mobile) {
    padding: 0 24px;
    width: 100%;
  }
}

.products__title {
  font-family: $font-heading;
  font-size: clamp(32px, 3vw, 46px);
  font-weight: 400;
  color: $color-ivory;
  margin-bottom: 14px;
}

.products__subtitle {
  font-family: $font-body;
  font-size: 14px;
  font-weight: 300;
  color: rgba($color-ivory, 0.6);
  line-height: 1.8;
}

.products__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  width: 100%;
  max-width: 1280px;

  @media (max-width: $bp-tablet) {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  @media (max-width: $bp-mobile) {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 0 24px 16px;
    scroll-padding-left: 24px;

    &::-webkit-scrollbar { display: none; }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}

.products__card {
  background-color: rgba($color-ivory, 0.04);
  border: 1px solid rgba($color-gold, 0.15);
  overflow: hidden;
  transition: transform $transition-base, border-color $transition-base;

  &:hover {
    transform: translateY(-6px);
    border-color: rgba($color-gold, 0.4);

    .products__card-img {
      transform: scale(1.06);
    }

    .products__card-overlay {
      opacity: 1;
    }
  }

  @media (max-width: $bp-mobile) {
    flex-shrink: 0;
    width: 72vw;
    scroll-snap-align: center;

    &:hover {
      transform: none;
    }

    .products__card-overlay {
      opacity: 1;
      background: rgba($color-forest, 0.35);
    }
  }
}

.products__card-img-wrap {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;

  @media (max-width: $bp-mobile) {
    aspect-ratio: 3 / 4;
  }
}

.products__card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s ease;
  filter: saturate(0.85);
  object-position: bottom;
}

.products__card-overlay {
  position: absolute;
  inset: 0;
  background: rgba($color-forest, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity $transition-base;
}

.products__card-btn {
  padding: 10px 28px;
  border: 1px solid $color-ivory;
  background: transparent;
  color: $color-ivory;
  font-family: $font-body;
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all $transition-base;

  &:hover {
    background-color: $color-ivory;
    color: $color-forest;
  }
}

.products__card-body {
  padding: 20px;

  @media (max-width: $bp-mobile) {
    padding: 14px;
  }
}

.products__card-collection {
  font-family: $font-body;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: $color-gold;
  display: block;
  margin-bottom: 6px;
}

.products__card-name {
  font-family: $font-body;
  font-size: 18px;
  font-weight: 400;
  color: $color-ivory;
  margin-bottom: 8px;
  line-height: 1.3;

}

.products__card-desc {
  font-family: $font-body;
  font-size: 12px;
  font-weight: 300;
  color: rgba($color-ivory, 0.55);
  line-height: 1.6;
  margin-bottom: 14px;
}

.products__card-price {
  font-family: $font-body;
  font-size: 14px;
  font-weight: 500;
  color: $color-gold-light;
  letter-spacing: 0.04em;
}

/* ── Modal ── */

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.72);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.modal {
  position: relative;
  background: $color-ivory;
  width: 100%;
  max-width: 860px;
  max-height: 90vh;
  overflow-y: auto;

  &::-webkit-scrollbar { display: none; }
  scrollbar-width: none;
}

.modal__close {
  position: absolute;
  top: 8px;
  right: 10px;
  background: none;
  border: none;
  font-size: 18px;
  color: rgba($color-forest, 0.45);
  cursor: pointer;
  z-index: 1;
  line-height: 1;
  transition: color $transition-base;
  padding: 12px;

  &:hover { color: $color-forest; }
}

.modal__layout {
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: $bp-mobile) {
    grid-template-columns: 1fr;
  }
}

.modal__img-wrap {
  overflow: hidden;

  @media (max-width: $bp-mobile) {
    aspect-ratio: 8 / 7;
  }
}

.modal__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: bottom;
  filter: saturate(0.85);
}

.modal__content {
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: $bp-mobile) {
    padding: 32px 24px 40px;
  }
}

.modal__collection {
  font-family: $font-body;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: $color-gold;
  display: block;
  margin-bottom: 10px;
}

.modal__name {
  font-family: $font-body;
  font-size: clamp(28px, 3vw, 40px);
  font-weight: 400;
  color: $color-forest;
  line-height: 1.15;
  margin-bottom: 8px;
}

.modal__price {
  font-family: $font-body;
  font-size: 15px;
  font-weight: 500;
  color: $color-gold-dark;
  margin-bottom: 20px;
}
.modal__notice{
  font-family: $font-body;
  font-size: 10px;
  font-weight: 500;
  color: red;
  margin-bottom: 20px;
}

.modal__divider {
  height: 1px;
  background: rgba($color-forest, 0.1);
  margin-bottom: 20px;
}

.modal__desc {
  font-family: $font-body;
  font-size: 14px;
  font-weight: 300;
  color: rgba($color-forest, 0.72);
  line-height: 1.9;
  margin-bottom: 28px;
}

.modal__notes {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 32px;
}

.modal__note {
  display: flex;
  gap: 16px;
  align-items: baseline;
}

.modal__note-type {
  font-family: $font-body;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.18em;
  color: $color-gold;
  min-width: 52px;
}

.modal__note-value {
  font-family: $font-body;
  font-size: 13px;
  font-weight: 300;
  color: rgba($color-forest, 0.75);
}

.modal__cta {
  display: block;
  width: 100%;
  padding: 16px;
  background-color: $color-forest;
  color: $color-ivory;
  text-align: center;
  font-family: $font-body;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color $transition-base;
  text-decoration: none;

  &:hover {
    background-color: $color-gold-dark;
  }
}

/* transition */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;

  .modal {
    transition: transform 0.25s ease;
  }
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;

  .modal {
    transform: translateY(16px);
  }
}
</style>
